import React, { useState } from 'react';
import {
  InputGrid,
  useResponsiveParams,
  Text,
  NotificationList,
  useQuantaFormikContext,
  Grid,
  GridItem,
} from 'quanta-ui';
import { useQuery } from '@apollo/client';
import { PREVIOUS_CLAIMS_DROPDOWN_DETAILS } from '../../../queries';
import {Loading}from 'quanta-flows/modules/layout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheck,
  faExclamation,
} from '@fortawesome/free-solid-svg-icons';

export default function PreviousClaims({
  productCode,
  productName,
  lobCode,
  lobName,
  quoteNumber,
  policyTenure,
  branding,
  modify,
}) {
  const { values, setFieldValue } = useQuantaFormikContext();
  const noOfColsMobile = 1,
    noOfColsDesktop = 3;

  let inputColSpans = useResponsiveParams({
    for_mobile: noOfColsMobile,
    for_desktop: noOfColsDesktop,
  });

  let screenSize = useResponsiveParams({
    for_mobile: 'mobile',
    for_desktop: 'desktop',
  });

  const [alerts, setAlerts] = useState([]);

  const { loading, data: dropDownDetails } = useQuery(
    PREVIOUS_CLAIMS_DROPDOWN_DETAILS,
    {
      fetchPolicy: 'cache-first',
      variables: {
        productCode: productCode,
      },
      skip: values?.isPrevInsuranceLoading,
      onCompleted: (data) => {
        setFieldValue(`previousYearNCBList`,data?.PRD_PreviousYearNCBSlabList)
        if (!values?.previousYearNCBSlab) {
          setFieldValue(
            'previousYearNCBSlab',
            data?.PRD_PreviousYearNCBSlabList[0]?.code,
          );
        }
       
        // if(values?.businessTypeValue?.toLowerCase() === 'new business'
        // ||values?.businessType?.toLowerCase() ==='new business'){
        // setFieldValue(
        //   'totalClaimCount',
        //   data?.PRD_TotalClaimCountList[0]?.code,
        // );
        // setFieldValue(
        //   'totalClaimCountValue',
        //   data?.PRD_TotalClaimCountList[0]?.value,
        // );
        // }
        if (!values?.totalClaimCount) {
          setFieldValue(
            'totalClaimCount',
            data?.PRD_TotalClaimCountList[0]?.code,
          );
          setFieldValue(
            'totalClaimCountValue',
            data?.PRD_TotalClaimCountList[0]?.value,
          );
        }
      },
      onError: (err) => {
        setAlerts([
          {
            header: 'No dropdown details',
            id: 1,
            content: (
              <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                <span>{err.message}</span>
              </div>
            ),
            type: 'error',
            timeout: null,
            disableClose: false,
          },
        ]);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
    },
  );

  if (loading) {
    return <Loading />;
  }
  if (values?.isPrevInsuranceLoading) {
    return <></>;
  }

  const {
    PRD_TotalClaimCountList,
    PRD_NoOfClaimsInYear1List,
    PRD_NoOfClaimsInYear2List,
    PRD_NoOfClaimsInYear3List,
    PRD_PreviousYearNCBSlabList,
  } = dropDownDetails;

  let grid_data = [
      {
          type: 'select',
          size: 'full',
          label:values?.businessTypeValue?.toLowerCase() === 'used car' ?  (
            <>
              Total Claim Count
            </>
          ) :(
            <>
              Total Claim Count<Text severity="error"> </Text>
            </>
          ),
          name: 'totalClaimCount',
          disabled: (values?.quotationNo !== '' && !modify) ||
                    values?.disableNCB
                    || values?.businessTypeValue?.toLowerCase() ==='used car'
                    || values?.businessType?.toLowerCase() ==='used car'
                    || values?.businessTypeValue?.toLowerCase() ==='new business'
                    || values?.businessType?.toLowerCase() ==='new business'
                    || (values?.businessType?.toLowerCase() === 'roll over' 
                    && values?.productVariant?.toLowerCase()?.search('liability only') !== -1),
          data: PRD_TotalClaimCountList
            ? [
                ...PRD_TotalClaimCountList.map((totalClaimCount) => {
                  return {
                    label: totalClaimCount.value
                      ? totalClaimCount.value
                      : '',
                    value: totalClaimCount.code
                      ? totalClaimCount.code
                      : '',
                  };
                }),
              ]
            : [],
          onDataChange: (val, setFieldValue) => {
            setFieldValue(
              `totalClaimCountValue`,
              PRD_TotalClaimCountList?.find(
                (claimCount) =>
                  claimCount?.code?.toLowerCase() ===
                  val?.toLowerCase(),
              )?.value,
            );
          },
        },
       

    {
      type: 'select',
      size: 'large',
      label: values?.businessTypeValue?.toLowerCase() === 'used car' 
            ||  values?.businessType?.toLowerCase() === 'used car' ||
            (values?.businessType?.toLowerCase() === 'roll over' 
                    && values?.productVariant?.toLowerCase()?.search('liability only') !== -1)
      ? (
        <>
          Previous Year NCB Slab
        </>
      ) :(
        <>
          Previous Year NCB Slab<Text severity="error"> *</Text>
        </>
      ),
      name: 'previousYearNCBSlab',
      iconPre: (
        <Text
          severity={
            (values?.quotationNo !== '' && !modify)  ? 'neutral-darker' : 'info'
          }
        >
          %
        </Text>
      ),
      disabled: (values?.quotationNo !== '' && !modify) ||
      values?.disableNCB||
                values?.businessTypeValue?.toLowerCase() === 'used car'
                || values?.businessType?.toLowerCase() ==='used car'
                || (values?.businessType?.toLowerCase() === 'roll over' 
                && values?.productVariant?.toLowerCase()?.search('liability only') !== -1),
      className: `${
        (values?.quotationNo !== '' && !modify)  ? 'border-neutral-dark' : ''
      }`,
      data: PRD_PreviousYearNCBSlabList
        ? [
            ...PRD_PreviousYearNCBSlabList.map(
              (previousYearNCBSlab) => {
                return {
                  label: previousYearNCBSlab.value
                    ? previousYearNCBSlab.value
                    : '',
                  value: previousYearNCBSlab.code
                    ? previousYearNCBSlab.code
                    : '',
                };
              },
            ),
          ]
        : [],
    },

    screenSize?.toString()?.toLowerCase() !== 'mobile'
      ? {
          type: 'render',
          component: () => <></>,
        }
      : null,
     screenSize?.toString()?.toLowerCase() !== 'mobile'
      ? {
          type: 'render',
          component: () => <></>,
        }
      : null,
  ].filter((d) => d);

  return (
    <div>
      {/* <Paper> */}
      <InputGrid
        data={grid_data}
        repeat={inputColSpans}
        titleType="title"
        titleSeverity="info"
        title={
          <Grid
            flow={'cols'}
            repeat={inputColSpans}
            className="w-full"
          >
            <GridItem
              colSpan={
                inputColSpans === noOfColsMobile ? inputColSpans : 1
              }
              className="w-full"
            >
              <Text type={'title'}>Previous Claims</Text>
            </GridItem>
            <GridItem
              colSpan={
                inputColSpans === noOfColsMobile ? inputColSpans : 2
              }
              className="full"
            >
              {(values?.isRegNoVerified === false ||
                values?.isPrevClaimsAvailable === false) && (
                <Text
                  type={'normal'}
                  severity={'error'}
                  className="flex space-x-2"
                >
                  <span>
                    <FontAwesomeIcon icon={faExclamation} />
                  </span>
                  <span>
                    We couldn't find any previous claim for your
                    vehicle, please enter manually
                  </span>
                </Text>
              )}
              {values?.isRegNoVerified &&
                values?.isPrevClaimsAvailable && (
                  <Text type={'normal'} className={'flex space-x-2'}>
                    <Text severity={'success'}>
                      <FontAwesomeIcon icon={faCheck} />
                    </Text>
                    <Text severity={'dark'}>
                      We have found below previous claim details for
                      your vehicle
                    </Text>
                  </Text>
                )}
            </GridItem>
          </Grid>
        }
        size="large"
        gapX={10}
      />
      {/* </Paper> */}
      <NotificationList {...{ items: alerts }} />
    </div>
  );
}
